import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-toast-message',
  templateUrl: './toast-message.component.html',
  styleUrls: ['./toast-message.component.scss']
})
export class ToastMessageComponent {
  @Input() message: string = '';
  @Input() icon: string = '';
  visible: boolean = false;

  show(message: string, icon: string) {
    this.message = message;
    this.icon = icon;
    this.visible = true;

    setTimeout(() => {
      this.visible = false;
    }, 3000);
  }
}